import { render, staticRenderFns } from "./rBingli_list.vue?vue&type=template&id=0f36fcc8&scoped=true&"
import script from "./rBingli_list.vue?vue&type=script&lang=js&"
export * from "./rBingli_list.vue?vue&type=script&lang=js&"
import style0 from "./rBingli_list.vue?vue&type=style&index=0&id=0f36fcc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f36fcc8",
  null
  
)

export default component.exports